<template>
  <div class="flex h-full flex-col items-stretch">
    <div class="mx-8 mb-4 mt-10 flex items-center justify-between">
      <button
        class="flex items-center gap-2"
        @click="emit('go-back')"
      >
        <IconArrowRight class="size-8 rotate-180 md:hidden" />
        <h2 class="block text-xl font-medium leading-none">Бонусная система</h2>
      </button>
      <BonusCoins />
    </div>

    <div class="mx-4 h-px bg-black opacity-10"></div>

    <div class="relative my-2 h-0 grow">
      <div class="absolute top-0 z-10 h-8 w-full bg-gradient-to-b from-whitegray to-transparent"></div>
      <div class="absolute bottom-0 z-10 h-8 w-full bg-gradient-to-t from-whitegray to-transparent"></div>
      <div class="h-full overflow-y-scroll py-8 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray">
        <div class="mx-8 flex flex-col items-stretch gap-4">
            <h1 class="block text-lg font-medium leading-none">Начисляем 💰cashback с каждым заказом!</h1>

            <h2 class="block font-medium leading-none mt-5">Как получить баллы:</h2>

            <ul class="list-disc list-inside">
                <li>зарегистрируйтесь на сайте или в мобильном приложении и получите welcome-бонус 150 баллов</li>
                <li>сделайте заказ на сайте или в приложении и получите cashback 10% от суммы заказа</li>
                <li>баллы будут начислены в течение суток после получения заказа</li>
                <li>баллы не начисляются на заказ со скидками и подарками</li>
                <li>1 балл = 1 рублю</li>
            </ul>

            <h2 class="block font-medium leading-none mt-5">Как потратить баллы:</h2>

            <ul class="list-disc list-inside">
                <li>оплатить можно не более 30% от суммы заказа и не более 2500 баллов от чека единоразово</li>
                <li>оплатить баллами можно только при заказе с сайта</li>
                <li>баллы нельзя списать при применении скидок и подарков</li>
                <li>сумма минимального заказа на доставку должна быть оплачена рублями</li>
            </ul>

            <h2 class="block font-medium leading-none mt-5">Когда сгорают баллы:</h2>

            <ul class="list-disc list-inside">
                <li>баллы сгорят через 60 дней с момента последнего заказ</li>
            </ul>


            <p>
                <i>Программа лояльности может быть изменена организатором акции<br />
                    Предложение действует с 07.10.2024г.<br />
                    Действует на момент публикации</i>
            </p>


            <!--<div class="rounded-xl bg-white shadow-main">
            <HeadlessDisclosure
              v-slot="{ open }"
              as="div"
            >
              <HeadlessDisclosureButton class="w-full px-6 py-4">
                <div class="flex items-center justify-between gap-8">
                  <span>Правила использования</span>
                  <IconArrowRight
                    class="h-6 invert transition-transform"
                    :class="{
                      'rotate-90': !open,
                      '-rotate-90': open,
                    }"
                  />
                </div>
              </HeadlessDisclosureButton>
              <HeadlessDisclosurePanel static>
                <div
                  class="grid grid-rows-[0fr] overflow-hidden transition-[grid-template-rows]"
                  :class="{
                    '!grid-rows-[1fr]': open,
                  }"
                >
                  <div class="min-h-0">
                    <div class="article p-6 pt-0">
                      <p>
                        Бонусы начисляются пользователю в качестве меры поощрения активности и/или в качестве меры
                        компенсации в следующих случаях:
                      </p>
                      <ul>
                        <li>в качестве поощрения в случае проведения Исполнителем рекламных акций;</li>
                        <li>
                          в размере до 30% от стоимости Товаров, имеющих пометку в виде монеты при условии оплаты их без
                          использования бонусов и скидок пользователя.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </HeadlessDisclosurePanel>
            </HeadlessDisclosure>
          </div>

          <div class="rounded-xl bg-white shadow-main">
            <HeadlessDisclosure
              v-slot="{ open }"
              as="div"
            >
              <HeadlessDisclosureButton class="w-full px-6 py-4">
                <div class="flex items-center justify-between gap-8">
                  <span>Бонусная система</span>
                  <IconArrowRight
                    class="h-6 invert transition-transform"
                    :class="{
                      'rotate-90': !open,
                      '-rotate-90': open,
                    }"
                  />
                </div>
              </HeadlessDisclosureButton>
              <HeadlessDisclosurePanel static>
                <div
                  class="grid grid-rows-[0fr] overflow-hidden transition-[grid-template-rows]"
                  :class="{
                    '!grid-rows-[1fr]': open,
                  }"
                >
                  <div class="min-h-0">
                    <div class="article p-6 pt-0">
                      <p>
                        Бонусная система — функциональность Приложения, предоставляющая пользователю возможность
                        получить Скидку на Товары и Услуги в размере и на условиях, указанных в приложении.
                      </p>
                    </div>
                  </div>
                </div>
              </HeadlessDisclosurePanel>
            </HeadlessDisclosure>
          </div>

          <div class="rounded-xl bg-white shadow-main">
            <HeadlessDisclosure
              v-slot="{ open }"
              as="div"
            >
              <HeadlessDisclosureButton class="w-full px-6 py-4">
                <div class="flex items-center justify-between gap-8">
                  <span>Срок хранения бонусов</span>
                  <IconArrowRight
                    class="h-6 invert transition-transform"
                    :class="{
                      'rotate-90': !open,
                      '-rotate-90': open,
                    }"
                  />
                </div>
              </HeadlessDisclosureButton>
              <HeadlessDisclosurePanel static>
                <div
                  class="grid grid-rows-[0fr] overflow-hidden transition-[grid-template-rows]"
                  :class="{
                    '!grid-rows-[1fr]': open,
                  }"
                >
                  <div class="min-h-0">
                    <div class="p-6 pt-0">
                      <p>
                        Если в течение 6 месяцев со дня последней покупки по карте клиент больше не производил расходные
                        операции, пропадают все бонусы.
                      </p>
                    </div>
                  </div>
                </div>
              </HeadlessDisclosurePanel>
            </HeadlessDisclosure>
          </div>
            -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['go-back'])
</script>
